import React from 'react'
import ReactModal from 'react-modal'
import Slider from 'react-slick'
import { map } from 'lodash'

import CloseCarousel from '../../assets/icons/close-carousel.svg'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '../../styles/scss/elements/images-slider.scss'

const PrevArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props} aria-label="Previous" type="button">
    <div className="image-carousel-arrow arrow-left" />
  </button>
)

const NextArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props} aria-label="Next" type="button">
    <div className="image-carousel-arrow arrow-right" />
  </button>
)

const ImagesSlider = ({
  photos,
  isCarouselOpen,
  closeCarouselModal,
  slideIndex,
}) => {
  const setttings = {
    dots: false,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
  }
  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isCarouselOpen}
      className="ylg-ms__accommodation-details__carousel-modal"
      overlayClassName="ylg-ms__accommodation-details__carousel-modal-overlay"
      parentSelector={() =>
        document.getElementById('ylg-ms__accommodation-details')
      }
    >
      <div className="images-slider-container">
        <Slider
          className="image-slider"
          {...setttings}
          prevArrow={<PrevArrow />}
          nextArrow={<NextArrow />}
          initialSlide={slideIndex}
        >
          {map(photos, (photoItem, index) => (
            <div key={index} className="image-slider__content">
              <p>{`${index + 1}/${photos.length}`}</p>
              <img
                className="slider-image"
                src={photoItem?.url}
                alt={photoItem?.caption}
              />
              <span>{photoItem?.caption}</span>
            </div>
          ))}
        </Slider>
        <button className="btn btn-close-carousel" onClick={closeCarouselModal}>
          <img
            src={CloseCarousel}
            alt="Close"
            className="icon-close-carousel"
          />
        </button>
      </div>
    </ReactModal>
  )
}
export default ImagesSlider
